import store from "@/store";

export function hasConfiguredAccessRight(right?: string | null) {
  if (right == null || right.trim() === "") {
    return true;
  }
  return store.getters["login/hasAccessRight"](right);
}
